import authService from 'commons/api/authService/authService';
import { defineStore } from 'pinia';

type State = {
  email?: string;
  originalEmail?: string;
  username?: string;
  originalUsername?: string;
};

export const useIdentityStore = defineStore('identity', {
  state: (): State => ({
    email: undefined,
    originalEmail: undefined,
    username: undefined,
    originalUsername: undefined,
  }),

  getters: {
    emailChanged(state) {
      return state.email !== state.originalEmail;
    },
    usernameChanged(state) {
      return state.username !== state.originalUsername;
    },
    usernameSetup(state): boolean {
      return !!(
        state.originalUsername && state.originalUsername !== state.originalEmail
      );
    },
    customUsername(state): string {
      return this.usernameSetup ? state.originalUsername : '';
    },
  },

  actions: {
    setData({
      username,
      email,
    }: {
      username: State['username'];
      email: State['email'];
    }) {
      this.username = username;
      this.originalUsername = this.username;
      this.email = email;
      this.originalEmail = this.email;
    },
    setUsername(username: State['username']) {
      this.username = username;
    },
    resetUsername() {
      this.username = this.originalUsername;
    },
    setEmail(email: State['email']) {
      this.email = email;
    },
    resetEmail() {
      this.email = this.originalEmail;
    },
    async fetchIdentity() {
      const { email, username } = await authService.getCurrentIdentity();
      this.setData({ email, username });
    },
    async saveEmail(password: string) {
      if (!this.email) return;

      const { email } = await authService.changeEmail({
        newEmail: this.email,
        password,
      });
      this.setData({ email, username: this.username });
    },
    async saveUsername() {
      if (!this.username) return;

      const { loginName } = await authService.changeUsername(this.username);
      this.setData({ email: this.email, username: loginName });
    },
  },
});
